// components/solicitudes-filter-bar.tsx
import React from 'react';
import { I18n } from 'core';
import styles from './solicitudes-filter-bar.module.scss';

export type Status = 'pendientes' | 'acabadas' | 'en curso' | 'todas';
export type Order = 'recientes' | 'antiguas' | undefined;

export interface FiltersUI {
  status: Status;
  order: Order;
  term: string;
}

interface Props {
  value: FiltersUI;
  onChange: (next: FiltersUI) => void;
  disabled?: boolean;
}

export const SolicitudesFilterBar = ({ value, onChange, disabled = false }: Props): JSX.Element => (
  <div className={styles.wrapper}>
    <label className={styles.item}>
      {I18n.t('SolicitudesFilter.estado')}
      <select
        className={styles.select}
        value={value.status}
        onChange={(e) => onChange({ ...value, status: e.target.value as Status })}
        disabled={disabled}
      >
        <option value="en curso">{I18n.t('SolicitudesFilter.enCurso')}</option>
        <option value="pendientes">{I18n.t('SolicitudesFilter.pendientes')}</option>
        <option value="acabadas">{I18n.t('SolicitudesFilter.acabadas')}</option>
        <option value="todas">{I18n.t('SolicitudesFilter.todas')}</option>
      </select>
    </label>

    <label className={styles.itemGrow}>
      {I18n.t('SolicitudesFilter.buscar')}
      <input
        className={styles.input}
        type="text"
        value={value.term}
        placeholder={I18n.t('SolicitudesFilter.placeholder')}
        onChange={(e) => onChange({ ...value, term: e.target.value })}
      />
    </label>
  </div>
);
